import React, { createContext, useContext, RefObject } from 'react'

interface IScrollableElementContext {
  scrollableElementRef: RefObject<HTMLDivElement | null>
}

interface IScrollableElementProviderProps {
  children: React.ReactNode
  scrollableElementRef: RefObject<HTMLDivElement | null>
}

const ScrollableElementContext = createContext<
  IScrollableElementContext | undefined
>(undefined)

export const useScrollableElement = (): IScrollableElementContext => {
  const context = useContext(ScrollableElementContext)
  if (!context) {
    throw new Error(
      'useScrollableElement must be used within a ScrollableElementProvider'
    )
  }
  return context
}

// Context created so dropdowns can close when the scrollable area is scrolled
// This is used in the GenerateTab/ModelSection/OptionDropdown component
// to close the dropdown when the scrollable area is scrolled
export const ScrollableElementProvider: React.FC<
  IScrollableElementProviderProps
> = ({ children, scrollableElementRef }) => {
  return (
    <ScrollableElementContext.Provider value={{ scrollableElementRef }}>
      {children}
    </ScrollableElementContext.Provider>
  )
}
